import React from 'react';
import { toInteger } from 'lodash';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { PAGE_DIRECTORY } from '../../../services/filter/constants';

import { filterPartnerOnCategory } from '../../../services/filter/actions';

import DirectoryPage from './DirectoryPage';
import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';
import { CategoryDirectoryTemplate } from '../../template/CategoryDirectoryTemplate';
import { getI18nByApp } from '../../../services/i18n/selector';

export class CategoryDirectoryPage extends React.Component {
    componentDidMount() {
        const { match } = this.props;
        const categoryId = Number(match.params.categoryId);
        if (categoryId) {
            this.props.filterPartnerOnCategory(PAGE_DIRECTORY, categoryId);
        }
    }

    render() {
        const { match, isCodePromo = false, category, Breadcrumb, i18n } = this.props;
        const isOffline = match.params.type === PATH.OFFLINE;
        const isEbon = match.params.type === PATH.EBON;

        return (
            <div>
                <HeadComponent title={category.label} description={category.label} />
                <LocalizedBreadcrumbItem to={`${PATH.CASHBACK_PATH}/${match.params.type}`}>
                    {isOffline
                        ? getI18nByApp(i18n, 'page.DIRECTORY.MOST_POPULAR.OFFLINE_TITLE')
                        : isEbon
                        ? getI18nByApp(i18n, 'page.DIRECTORY.MOST_POPULAR.EBON_TITLE')
                        : getI18nByApp(i18n, 'page.DIRECTORY.MOST_POPULAR.ONLINE_TITLE')}
                </LocalizedBreadcrumbItem>
                <LocalizedBreadcrumbItem to={match.url}>{category.label}</LocalizedBreadcrumbItem>
                <DirectoryPage
                    categoryId={category && category.id ? toInteger(category.id) : -1}
                    isCodePromo={isCodePromo}
                    Breadcrumb={Breadcrumb}
                    isOffline={isOffline}
                    isEbon={isEbon}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        i18n: state.i18n,
        category: state.category.categories[ownProps.match.params.categoryId] || {}
    };
};

const mapDispatchToProps = {
    filterPartnerOnCategory
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(CategoryDirectoryPage),
    CategoryDirectoryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/directory/CategoryDirectoryPage.js